export const dynamicColumns = (self, score) => [
  {
    title: '题目分类',
    dataIndex: 'categoryParentName',
    key: 'categoryParentName',
    width: 200
  },
  {
    title: '题型',
    dataIndex: 'typeTitle',
    key: 'typeTitle',
    width: 100
  },
  {
    title: '难度',
    dataIndex: 'difficultyTitle',
    key: 'difficultyTitle',
    width: 80
  },
  {
    title: '题目数量',
    dataIndex: 'size',
    key: 'size',
    width: 80
  },
];


